<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
  <path d="M10 5.5V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.11165 6.55288L6.14746 5.40381" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.8975 6.55288L13.8617 5.40381" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.5 15.25H6.51374C7.64847 15.25 8.6056 14.405 8.74637 13.279L8.93387 11.779C9.10172 10.4362 8.05461 9.24997 6.70124 9.24997H6.625L6.09675 8.89777C5.71668 8.64442 5.24736 8.56312 4.80422 8.67389C4.29917 8.80019 3.88547 9.16132 3.69213 9.64462L3.25 10.75H2.5" 
  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17.5004 15.25H13.4867C12.352 15.25 11.3948 14.405 11.254 13.279L11.0665 11.779C10.8987 10.4362 11.9458 9.24997 13.2992 9.24997H13.3754L13.9037 8.89777C14.2837 8.64442 14.7531 8.56312 15.1962 8.67389C15.7012 8.80019 16.1149 9.16132 16.3083 9.64462L16.7504 10.75H17.5004" 
  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: 'CreatorPartnershipIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>